import { IGetItemsResult } from '../ServerApi/types/IGetItemsResult';
import { IPagedItemsParams } from '../ServerApi/types/IPage';
import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import { IListFetcher } from './IListFetcher';
import { ListResult } from './ListResult';
import WebHttpClient from '../../httpClient/WebHttpClient';

export class ServerResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListFetcher<TResource> {

  constructor(private requestType: new (params: IPagedItemsParams) => IRequest<IPagedItemsParams, TRequestResult>,
              private resultMapper: (result: TRequestResult) => TResource[]) { }

  public fetchList(params: IPagedItemsParams): Promise<ListResult<TResource>> {
    return WebHttpClient.sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const startIndex = params.page ? params.page.startIndex : 0;
        return new ListResult<TResource>(this.resultMapper(result), startIndex, result.totalCount);
      });
  }

}
